import Swiper from "swiper/bundle";

const slider = () => {
  let child = new Swiper(".single-sales-slider__child-inner", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      // 768px以上の場合
      768: {
        spaceBetween: 20,
      },
    }
  });
  let parent = new Swiper(".single-sales-slider__parent", {
    spaceBetween: 10,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: ".single-sales-slider__btn-next",
      prevEl: ".single-sales-slider__btn-prev",
    },
    thumbs: {
      swiper: child,
    },
  });
}

export default function SALES () {
  slider();
}